import { createConsumer } from '@rails/actioncable';

export const applicationConsumer = createConsumer();
